import React from 'react'
import SportsLayoutComp from '../../../components/sports/sports layout/SportsLayoutComp'

const Pesapallo = () => {
  return (
    <SportsLayoutComp name={'Pesapallo'}/>
  )
}

export default Pesapallo